import React from 'react';
import {tap} from 'rxjs/operators';

import ajax from 'iss/utils/ajax';
import subscribeTo from 'iss/utils/subscriptionUtils';

export const evaluationEvents = ajax.cache("/event?timezone=UTC", 5 * ajax.MINUTES);

export function searchLateEvents(query, sortBy, sortOrder, page, pageSize, showLoadingScreen = true) {

  const qp = {
    query: encodeURIComponent(query),
    onlyLate: 1,
    states: 'READY_FOR_EVALUATION,READY_FOR_CORRECTIONAL_REMARKS,STARTED',
    page: page,
    size: pageSize,
    sortBy: sortBy,
    sortOrder: sortOrder
  };

  const qs = Object.entries(qp).map(e => `${e[0]}=${e[1]}`).join('&');
  return ajax.getJson(`/event/search?${qs}`, {showLoadingScreen});
}

export function getEvents() {
    return evaluationEvents;
}

const clearCachesAfterDone = tap(evaluationEvents.clearCache, evaluationEvents.clearCache);

export function getEvent(id) {
    return ajax.getJson(`/event/${id}?timezone=UTC`);
}

export function createEvent(event) {
  return ajax.postJson("/event", event, {resultType: 'text'});
}

export function updatePlannedDate(id, event) {
     return ajax.putJson("/event/" + id , event, {resultType: 'text'})
       .pipe(clearCachesAfterDone);
}

export function cancelEvent(id, cancelInfo) {
     return ajax.putJson("/event/" + id + "/cancel", cancelInfo, {resultType: 'text'})
       .pipe(clearCachesAfterDone);
}

export function submitSelfMonitoring(id) {
  return ajax.putJson("/event/" + id + "/cleaned", undefined, {resultType: 'text'})
    .pipe(clearCachesAfterDone);
}

export function startEvent(id) {
     return ajax.putJson("/event/" + id + "/start")
       .pipe(clearCachesAfterDone);
}

export function reActivateEvent(id, description) {
     return ajax.putJson("/event/" + id + "/reactivate", description, {bodyType: 'plain', resultType: 'text'})
       .pipe(clearCachesAfterDone);
}

export function submitAnswers(id, data) {
  return ajax.putJson("/event/" + id + "/answers", data, {resultType: 'text'})
    .pipe(clearCachesAfterDone);
}

export function submitCorrectionalRemarks(id, data) {
  return ajax.putJson("/event/" + id + "/correctional_remarks", data, {resultType: 'text'})
    .pipe(clearCachesAfterDone);
}

export function getPreviousAnswers(id) {
  return ajax.getJson("/event/"+id+"/answers");
}

export function reviewEvent(id, data) {
  return ajax.putJson("/event/" + id + "/reviewed", data, {resultType: 'text'})
    .pipe(clearCachesAfterDone);
}

export const eventCancelReasons = [
  "INTERNAL_REASON",
  "CONTRACT_ENDED",
  "TEMPORARILY_CLOSED",
  "NOT_MY_RESPONSIBILITY",
  "OTHER_REASON",
];

export const eventStates = {
  selfMonitoring: "SELF_MONITORING",
  readyForEvaluation: "READY_FOR_EVALUATION",
  started: 'STARTED',
  readyForCorrectionalRemarks: "READY_FOR_CORRECTIONAL_REMARKS",
  readyForReview: "READY_FOR_REVIEW",
  finished: "FINISHED",
  cancelled: "CANCELLED",
  deleted: "DELETED"
};

export function subscribeToEvent(WrappedComponent, ErrorComponent) {
  return function EvaluationEventEdit({eventId, ...props}) {
    const SubscribedComponent = subscribeTo(getEvent(eventId), 'event', WrappedComponent, ErrorComponent);

    return <SubscribedComponent {...props} />;
  };
}



// WEBPACK FOOTER //
// ./modules/issFrontend/service/EvaluationEventService.js